
import React from 'react';
import { LogoSpinner } from '@/components/ui/logo-spinner';
import { cn } from '@/lib/utils';

type LoadingScreenProps = {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

/**
 * Unified loading screen component for consistent loading UX across the app
 */
export const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  size = 'lg',
  className 
}) => {
  return (
    <div className={cn(
      "min-h-screen bg-background flex items-center justify-center",
      className
    )}>
      <LogoSpinner size={size} />
    </div>
  );
};
